import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, Phone, Mail, CalendarCheck, X } from "lucide-react";
import { COMPANY } from "../../data";
import { trackEvent } from "../../lib/analytics";

// tel: and mailto: clicks are reported by the sitewide listener (lib/analytics installClickTracking) as phone_click /
// email_click with location "widget"; only the SMS link needs its own event.
const OPTIONS = [
  { icon: MessageSquare, label: "Text us", sub: COMPANY.phone, href: "sms:2067953616", event: "text_us", testId: "widget-text_us" },
  { icon: Phone, label: "Call us", sub: COMPANY.phone, href: COMPANY.phoneHref, testId: "widget-click_to_call" },
  { icon: Mail, label: "Email", sub: COMPANY.email, href: `mailto:${COMPANY.email}`, testId: "widget-email_us" },
];

export const TextWidget = () => {
  const [open, setOpen] = useState(false);
  // Tablets and desktop: the sticky Call / Free visit bar covers contact on phones (<768px), so the two never overlap.
  return (
    <div className="hidden md:block fixed z-40 right-6 bottom-6" data-testid="text-widget">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 16, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 16, scale: 0.95 }} transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="mb-3 w-[280px] bg-[#111] border border-white/10 rounded-2xl overflow-hidden shadow-2xl" data-testid="text-widget-panel">
            <div className="bg-[#FF9000] px-5 py-4">
              <div className="font-display text-lg text-[#111] uppercase leading-none">Talk to the builder</div>
              <div className="text-[#111]/70 text-xs font-semibold mt-1">We reply fast — no phone tree.</div>
            </div>
            <div className="p-2">
              {OPTIONS.map((o) => (
                <a key={o.label} href={o.href} data-location="widget" onClick={o.event ? () => trackEvent(o.event, { source: "text_widget" }) : undefined} className="flex items-center gap-3 p-3 rounded-xl hover:bg-white/5 transition-colors" data-testid={o.testId}>
                  <span className="h-10 w-10 rounded-full bg-[#FF9000]/15 grid place-items-center shrink-0"><o.icon size={18} className="text-[#FF9000]" /></span>
                  <span><span className="block text-white font-bold text-sm">{o.label}</span><span className="block text-white/50 text-xs">{o.sub}</span></span>
                </a>
              ))}
              <Link to="/contact" data-cta="free-visit" data-location="widget" onClick={() => setOpen(false)} className="mt-1 btn-accent rounded-xl w-full py-3 flex items-center justify-center gap-2 text-sm uppercase tracking-wider" data-testid="widget-free-visit"><CalendarCheck size={16} /> Free advice visit</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <button onClick={() => setOpen((v) => !v)} aria-label={open ? "Close contact menu" : "Contact us"} data-testid="text-widget-toggle"
        className="ml-auto flex h-14 w-14 items-center justify-center rounded-full btn-accent shadow-xl">
        <AnimatePresence mode="wait" initial={false}>
          <motion.span key={open ? "x" : "m"} initial={{ rotate: -90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: 90, opacity: 0 }} transition={{ duration: 0.2 }}>
            {open ? <X size={24} className="text-[#111]" /> : <MessageSquare size={24} className="text-[#111]" />}
          </motion.span>
        </AnimatePresence>
      </button>
    </div>
  );
};
